<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useI18n } from "vue-i18n"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            heading1: "Oups !",
            sub_title:
                "Désolé, une erreur s'est produite lors du traitement de votre paiement ou de la validation de votre souscription.",
            button: "Contacter le support",
            texts_failure:
                "Si le problème persiste, n'hésitez pas à nous contacter pour obtenir de l'aide. Merci pour votre compréhension.",
            text_website: "Aller sur Homeys.fr",
            text_contact: "Contactez-nous",
            back: "Retour",
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
const emit = defineEmits<{
    (e: "back"): void
}>()

// ================================
// INTERACTIONS
// ================================
/** Retour à l'étape précédente (récap). */
function onBack(): void {
    emit("back")
}

/** Ouvre le client mail pour contacter le support. */
function onContactSupport(): void {
    window.location.href = "mailto:contact@homeys.io"
}
</script>

<template>
    <BaseCard
        class="subscription-form-failure flex flex-col justify-center items-center gap-10 w-full p-8"
        :pt="{
            content: 'flex flex-col justify-center items-center gap-10',
            header: 'flex flex-col justify-center items-center gap-4',
        }"
    >
        <template #header>
            <h1 class="text-xl font-semibold text-primary-900 text-center">
                {{ t("heading1") }}
            </h1>
            <h2 class="text-base font-medium text-primary-800 text-center">
                {{ t("sub_title") }}
            </h2>
        </template>
        <template #content>
            <p class="text-sm text-primary-700 text-center whitespace-pre-line">
                {{ t("texts_failure") }}
            </p>
            <div class="flex flex-col sm:flex-row gap-3 w-full justify-center">
                <BaseButton
                    :label="t('back')"
                    severity="secondary"
                    outlined
                    @click="onBack"
                />
                <BaseButton :label="t('button')" @click="onContactSupport" />
            </div>
            <div
                class="flex flex-row gap-4 items-center justify-center flex-wrap"
            >
                <a
                    href="https://www.homeys.fr/"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-sm text-primary-600 underline"
                >
                    {{ t("text_website") }}
                </a>
            </div>
        </template>
    </BaseCard>
</template>
